import PropTypes from 'prop-types';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';

function ProtectedRoute({ Component }) {
  const { user } = useAuth();
  const isLoggedIn = !!user;

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return Component ? <Component /> : <Outlet />;
}

ProtectedRoute.propTypes = {
  Component: PropTypes.elementType,
};

export default ProtectedRoute;
